<template>
  <v-app id="app">
    <HeaderContainer />
    <ContentContainer />
    <LeftWidgetsContainer />
    <RightWidgetsContainer />
    <FooterContainer />
  </v-app>
</template>

<script>
import HeaderContainer from './containers/Header';
import ContentContainer from './containers/ContentContainer';
import LeftWidgetsContainer from './containers/LeftWidgets';
import RightWidgetsContainer from './containers/RightWidgets';
import FooterContainer from './containers/FooterContainer';

import { mapActions, mapMutations, mapGetters } from 'vuex';

export default {
  name: 'HPAttackVizualizationApp',
  components: {
    HeaderContainer,
    ContentContainer,
    LeftWidgetsContainer,
    RightWidgetsContainer,
    FooterContainer
  },
  data: () => ({
    intervalIds: []
  }),
  methods: {
    ...mapActions({
      fetchData: 'eventStore/fetchEvents',
      refreshEvents: 'eventStore/refreshEvents',
      mergePastEvents: 'eventStore/mergePastEvents'
    }),
    ...mapMutations(['refreshToCurrentTime'])
  },
  computed: {
    ...mapGetters({ attacksByTimestamp: 'eventStore/attacksByTimestamp' })
  },
  async mounted() {
    // kick off the time tick-tocker what will ultimately triggers
    // every new projectile to start animating
    // also refresh the pastEvents from here
    const timestampIncrement = window.setInterval(() => {
      this.refreshToCurrentTime();
      this.mergePastEvents(this.attacksByTimestamp);
    }, 1000);

    // fetch initial data
    await this.fetchData();
    // and kick off further fetches at every 6 minutes
    const dataFetcherId = setInterval(this.fetchData, 1000 * 60 * 5);

    // kick off the refreshing of smaller dataset from the big events set
    // this is to help gain performance
    // basically the timers timestamp will be matched against this constantly
    // refreshed array
    this.refreshEvents();
    const refreshEventsId = setInterval(this.refreshEvents, 1000 * 60);

    this.intervalIds = [...this.intervalIds, timestampIncrement, dataFetcherId, refreshEventsId];
  },
  destroyed() {
    this.intervalIds.forEach((id) => {
      window.clearInterval(id);
    });
  }
};
</script>

<style lang="scss">
// resets
html,
body,
div,
span,
a {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
// no overflows
html,
body {
  min-height: 100vh;
  min-width: 100vw;
  background: #15364c;
  overflow: hidden;
}
</style>

<style lang="scss" scoped>
#app {
  position: relative;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  margin: 0;
  padding: 0;
  background: radial-gradient(circle, #15364c, #0f2133);
  font-family: Helvetica, Arial, sans-serif;
  color: white;
}
</style>
